<app-core-popup
  [header]="'icd-codes.header' | translate"
  [dialogStyle]="{ width: '80%' }"
  (closeOn)="onPopupClosed()"
  [saveText]="'common.save' | translate"
  [maximizable]="true"
  (chooseOn)="save()"
  #popup
>
  <div class="row">
    <div class="col-lg-6 col-md-4 mb-2">
      <div class="card-above d-flex align-items-center p-3">
        <div class="form-check me-4">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            [(ngModel)]="selectedFilter"
            (ngModelChange)="onRadioChange()"
            [value]="'all'"
          />
          <label class="form-check-label" for="flexRadioDefault1">
            {{ "icd-codes.all" | translate }}
          </label>
        </div>
        <div class="form-check" *ngIf="showOftenUsage">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            [value]="'oftenUsage'"
            [(ngModel)]="selectedFilter"
            (ngModelChange)="onRadioChange()"
          />
          <label class="form-check-label" for="flexRadioDefault2">
            {{ "icd-codes.often-usage" | translate }}
          </label>
        </div>
      </div>
      <app-cards
        footerDivider="border-0 pb-0 "
        headerStyle="d-none"
        class="custom-cardbox-area"
      >
        <div bodyContent class="row">
          <div class="col-12 mb-3 d-flex">
            <div class="search-container">
              <input
                type="text"
                [placeholder]="'common.search' | translate"
                (ngModelChange)="onSearch($event)"
                [(ngModel)]="searchText"
                class="form-control"
              />
              <i class="fa fa-search search-icon"></i>
            </div>
          </div>

          <p-tree
            [value]="filteredIcdCodes"
            class="w-full md:w-30rem"
            [style]="{ width: '100%' }"
            [(selection)]="selectedIcdCodes"
            [emptyMessage]="'icd-codes.empty-message' | translate"
          >
            <ng-template let-node pTemplate="default">
              <div
                class="custom-node leaf-node"
                [ngClass]="{
                  'selected-node': isNodeSelected(node)
                }"
                (click)="onNodeClick(node, $event)" role="button"  tabindex="-1"
              >
                <span>{{ node?.data?.code }} - {{ node.label }}</span>
              </div>
            </ng-template>
          </p-tree>
          <app-loading [loading]="searchLoading"></app-loading>
        </div>
      </app-cards>
    </div>

    <div class="col-lg-6 col-md-4 mb-2">
      <div class="card-above"></div>

      <app-cards
        footerDivider="border-0 pb-0 "
        [title]="'icd-codes.right-card-header' | translate"
        class="custom-cardbox-area"
      >
        <div bodyContent>
          <div
            class="d-flex justify-content-between align-items-center mb-2"
            *ngFor="let icd of selectedIcdCodes"
          >
            <div>
              {{ icd?.data?.code }} - {{ icd?.label }}
            </div>
            <button
              type="button"
              class="btn btn-danger btn-icon-xxs me-3"
              (click)="deleteIcd(icd)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </app-cards>
    </div>

    <app-loading [loading]="loading" [fullScreen]="true"></app-loading>
  </div>
</app-core-popup>
